import { useEntryPriceAfterSpread } from '@ui/features/Trade/hooks/useEntryPriceAfterSpread';
import { useOpenPositionPairSpreadPercentage } from '@ui/features/Trade/hooks/useOpenPositionPairSpreadPercentage';
import { useLeverage } from '@ui/features/Trade/store/useLeverage';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';

import {
  useGetTargetMaxTpRatios,
  useGetTargetMaxTpRatiosPrice,
} from '../../../hooks/useGetTargetMaxTpRatios';
import { useIsLong } from '../store/useIsLong';

export const useCurrentPairMaxTpRatios = () => {
  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());

  const leverage = useLeverage();

  return useGetTargetMaxTpRatios(currentTradePairInfo.address, leverage);
};

// use only for open position
export const useCurrentPairMaxTpRatiosPrice = () => {
  const isLong = useIsLong((s) => s._persistValue);
  const entryPrice = useEntryPriceAfterSpread();
  const leverage = useLeverage();
  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());

  const openPositionPairSpreadPercentage = useOpenPositionPairSpreadPercentage({
    isClosePrice: false,
  });

  return useGetTargetMaxTpRatiosPrice({
    pairBase: currentTradePairInfo.address,
    leverage,
    marketPrice: entryPrice?.toNumber(),
    isLong,
    spreadPercentage: openPositionPairSpreadPercentage,
  });
};
